<script>
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import tlptalep from "@/models/tlptalep";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
import addedit from "./addedit";
export default {
  mixins: [Api, Sabit, tlptalep],
  page: {
    title: "Taleplerim",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader, treeselect, addedit
  },
  data() {
    return {
      title: "Taleplerim",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Taleplerim",
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: 1,
        PageSize: 10,
        PageDataSize: 1,
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      loading: true,
      Filter: {
        Takipno: null,
        Atananbirimid: null,
        Durumid: null,
        Oncelikid: null,
        Atananpersonelid: null,
        Baslik: null,
        Tamamlananharic: null
      },
      APPLICATION_TYPE: JSON.parse(localStorage.getItem('config')).APPLICATION_TYPE,
      
      FilterText: null,
    };
  },
  watch: {
    "Filter.Baslik"() {
      this.Get()
    }
  },
  methods: {
    Get() {
      this.FilterText= "&Desc=Takipno"

      if (this.Filter.Baslik != null && this.Filter.Baslik != "") {
        this.FilterText += "&Baslik=" + this.Filter.Baslik
      }
      if (this.Filter.Takipno != null && this.Filter.Takipno != "") {
        this.FilterText += "&Takipno=" + this.Filter.Takipno
      }
      if (this.Filter.Atananbirimid != null && this.Filter.Atananbirimid != "") {
        this.FilterText += "&Atananbirimid=" + this.Filter.Atananbirimid
      }
      if (this.Filter.Durumid != null && this.Filter.Durumid != "") {
        this.FilterText += "&Durumid=" + this.Filter.Durumid
      }
      if (this.Filter.Oncelikid != null && this.Filter.Oncelikid != "") {
        this.FilterText += "&Oncelikid=" + this.Filter.Oncelikid
      }
      if (this.Filter.Atananpersonelid != null && this.Filter.Atananpersonelid != "") {
        this.FilterText += "&Atananpersonelid=" + this.Filter.Atananpersonelid
      }

      if (this.Filter.Tamamlananharic != null && this.Filter.Tamamlananharic != "") {
        this.FilterText += "&Tamamlananharic=" + this.Filter.Tamamlananharic
      }

      this.FilterText += "&Olusturanid=" + this.TokenPersonelId
      this.ActionsFilterGet({
        Service: "tlptalep",
        Page: this.Page,
        Filter: this.FilterText,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.loading = false;
      });
    },
    goToDetailPage(Id) {
      const routeData = this.$router.resolve({ name: 'talepdetail', params: { Talepid: Id }, });
      window.open(routeData.href, '_blank');
    },

  },
};
</script>

<template>
  <Loader :loading="loading">
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="accordion mb-3">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseOne">
                      Filtreleme
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingOne">
                    <div class="accordion-body">

                      <div class="row">

                        <b-form-group class="col-lg-3" label="Takip Numarası">
                          <b-form-input v-model="Filter.Takipno" type="number"></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-lg-3" label="Başlık">
                          <b-form-input v-model="Filter.Baslik" type="text"></b-form-input>
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Atananbirimid.FieldTitle"
                          :key="Filter.Atananbirimid">
                          <treeselect :multiple="false" :options="FormDataType.Atananbirimid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atananbirimid" />
                          <treeselect-value :value="Filter.Atananbirimid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Durumid.FieldTitle"
                          :key="Filter.Durumid">
                          <treeselect :multiple="false" :options="FormDataType.Durumid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Durumid" />
                          <treeselect-value :value="Filter.Durumid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text" :label="FormDataType.Oncelikid.FieldTitle"
                          :key="Filter.Oncelikid">
                          <treeselect :multiple="false" :options="FormDataType.Oncelikid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Oncelikid" />
                          <treeselect-value :value="Filter.Oncelikid" />
                        </b-form-group>

                        <b-form-group class="col-lg-3" label-for="text"
                          :label="FormDataType.Atananpersonelid.FieldTitle" :key="Filter.Atananpersonelid">
                          <treeselect :multiple="false" :options="FormDataType.Atananpersonelid.ComboDataArray"
                            placeholder="Seçiniz..." v-model="Filter.Atananpersonelid" />
                          <treeselect-value :value="Filter.Atananpersonelid" />
                        </b-form-group>


                        <b-form-group class="col-lg-2" label="Tamamlananalar Hariç">
                          <b-form-checkbox value="true" v-model="Filter.Tamamlananharic" plain></b-form-checkbox>
                        </b-form-group>

                        <div class="col-lg-4">
                          <button class="btn btn-success " data-bs-dismiss="offcanvas" type="button" @click="Get()">
                            Filtreleme
                          </button>
                        
 
                          <b-dropdown variant="success" class="btn  btn-rounded   me-2">
                            <template v-slot:button-content>
                              <i class="mdi mdi-file-export-outline me-1"></i>Yazdır <i
                                class="mdi mdi-chevron-down"></i>
                            </template>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepdurum', DowlandName: 'Talep Durum Raporu', FileName: 'tlptaleplerim', FileFormat: 'xlsx', Filter: FilterText })">Excel</b-dropdown-item>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepdurum', DowlandName: 'Talep Durum Raporu', FileName: 'tlptaleplerim', FileFormat: 'pdf', Filter: FilterText })">Pdf</b-dropdown-item>
                            <b-dropdown-item href="javascript: void(0);"
                              @click="Report({ Service: 'tlptalep/print/tlptalepdurum', DowlandName: 'Talep Durum Raporu', FileName: 'tlptaleplerim', FileFormat: 'docx', Filter: FilterText })">Word</b-dropdown-item>
                          </b-dropdown>
                     </div>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>Takip No</th>
                      <th>Başlık</th>
                      <th>İçerik</th>
                      <th>Tahmini Bitiş Tarihi</th>
                      <th>Talep Tipi</th>
                      <th>Atanan Birim</th>
                      <th>Durum</th>
                      <th>Öncelik</th>
                      <th v-if="APPLICATION_TYPE != '3'">Atanan Personel</th>
                      <th class="
                            action-is
                            w-100
                            d-flex
                            justify-content-center
                            align-items-center
                          ">İşlem</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <th scope="row">{{ Data.Takipno }}</th>
                      <td>{{ Data.Baslik }}</td>
                      <td>{{ Data.Aciklama }}</td>
                      <td>{{ Data.Tahminibitis != null ? formatDateTable(Data.Tahminibitis) : '' }}</td>
                      <td>{{ Data.Taleptip }}</td>
                      <td>{{ Data.Atananbirim }}</td>
                      <td>{{ Data.Durum }}</td>
                      <td>{{ Data.Oncelik }}</td>
                      <td v-if="APPLICATION_TYPE != '3'">{{ Data.Atananpersonel }}</td>
                      <td>
                        <div class="
                            action-is
                            w-100 
                            d-flex
                            justify-content-center
                            align-items-center
                          ">
                          <b-button-group>
                            <b-button v-b-tooltip.hover title="Detay" variant="info" @click="goToDetailPage(Data.Id)"><i
                                class="far fa-eye"></i></b-button>
                            <b-button v-if="0" v-b-tooltip.hover title="Düzenle" variant="success" v-b-modal.tlptalep
                              @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="far fa-edit"></i></b-button>
                            <b-button variant="danger" v-b-tooltip.hover title="Sil"
                              @click="Delete('tlptalep', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                          </b-button-group>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <div class="d-flex justify-content-between align-items-center mb-2">


                  <div class="text-muted">
                    Toplam <b>{{ Page.PageDataSize }}</b> kayıt 
                  </div>

                  <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage"
                    :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table"
                    :limit="Math.min(5, Math.ceil(Page.PageDataSize / Page.PageSize))"
                    @page-click="ChangePage($event, (Page.PageDataSize / Page.PageSize))">
                  </b-pagination>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <addedit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" :Geldigiyer="2" />
    </Layout>
  </Loader>
</template>
